export enum ContactTypeEnum {
    Member = 1,
    Dependent = 2,
    Client = 3,
    MasterClient = 4,
    LawFirm = 5,
    HR = 6,
    AccountManager = 7,
    PotencialMember =8
}